import React from "react";
const SvgDsAirConditioned = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M3 7.5a1 1 0 00-1 1v6a1 1 0 001 1h18a1 1 0 001-1v-6a1 1 0 00-1-1H3zm0 1h18v6h-1v-1a1 1 0 00-1-1H5a1 1 0 00-1 1v1H3v-6zm2 6h14v-.999L5 13.5v1zM6 17a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 016 17zm3 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 019 17zm3 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm3 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm3 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsAirConditioned;
